'use client';

/* Don't import CSS files from the ‘swiper’ library. They're already imported in ‘styles/swiper.css’ */
import { clsx } from 'clsx';
import { FC, PropsWithChildren } from 'react';
import { Navigation, Pagination, Virtual } from 'swiper/modules';
import { Swiper, SwiperProps } from 'swiper/react';
import styles from './Carousel.module.css';

export { SwiperSlide as Slide } from 'swiper/react';

export const Carousel: FC<
  PropsWithChildren & SwiperProps & { sliderClassName?: string }
> = ({ children, pagination, modules, sliderClassName, ...props }) => {
  return (
    <Swiper
      modules={[Virtual, Navigation, Pagination, ...(modules ? modules : [])]}
      pagination={{
        enabled: false,
        clickable: true,
        bulletClass: styles.bullet,
        bulletActiveClass: styles.bulletActive,
        ...(typeof pagination !== 'boolean' ? pagination : {}),
      }}
      className={clsx(styles.slider, sliderClassName as string)}
      {...props}
    >
      {children}
    </Swiper>
  );
};
